<template>
  <div>
    <el-dialog
      v-if="visible"
      visible
      show-close
      width="800px"
      :title="$l('dialog_title_detail') || '费用部门详情'"
      :before-close="() => close()"
      v-el-dialog-drag
    >
      <Main ref="main" :costSectorCode="costSectorCode" />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_close') || '取消' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    costSectorCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
